import api from "./api.js";
import URLS from "../utils/urls.js";

export const getSecurityRecommendationsDetails = payload => {
  return api.post(URLS.BACKEND_API + `/security/get_security_details`, {
    ...payload
  });
};
